/* Nuvoza 5-minute visual timer; no inventory is held or offer expired. */
(function(){
  if(window.nuvozaCartTimerLoaded)return;
  window.nuvozaCartTimerLoaded=true;
  var key='nuvoza_cart_timer_start_5min_v2', period=300000;
  var fallbackStart=0, drawerWasOpen=false;
  function getStart(){
    var start=0;
    try{start=Number(sessionStorage.getItem(key))||0;}catch(e){start=fallbackStart;}
    if(!start || start>Date.now())return 0;
    return start;
  }
  function setStart(start){
    fallbackStart=start;
    try{sessionStorage.setItem(key,String(start));}catch(e){}
  }
  function reset(){
    var now=Date.now();setStart(now);return now;
  }
  function isExpired(){var start=getStart();return !!start && Date.now()-start>=period;}
  // No countdown is created until the cart contains an item.
  function tick(){
    var drawer=document.getElementById('CartDrawer');
    var timer=drawer && drawer.querySelector('[data-nuvoza-cart-timer]');
    if(!timer)return;
    var start=getStart();
    var remaining=start?Math.max(0,period-(Date.now()-start)):period;
    var expired=!!start && remaining===0;
    var sec=Math.ceil(remaining/1000);
    var display=String(Math.floor(sec/60)).padStart(2,'0')+':'+String(sec%60).padStart(2,'0');
    if(timer.textContent!==display)timer.textContent=display;
    var countdown=drawer.querySelector('.nuvoza-cart-countdown');
    var expiredBox=drawer.querySelector('.nuvoza-cart-expired-message');
    if(countdown)countdown.hidden=!start || expired;
    if(expiredBox)expiredBox.hidden=!expired;
  }
  function activateIfCartHasItems(){
    if(getStart())return;
    if(typeof window.fetch!=='function')return;
    window.fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.ok?r.json():null;}).then(function(cart){
      if(cart && cart.item_count>0 && !getStart()){reset();tick();}
    }).catch(function(){});
  }
  function isAdd(url){return /\/cart\/add(?:\.js)?(?:\?|$)/.test(String(url||''));}
  if(typeof window.fetch==='function'){
    var oldFetch=window.fetch;
    window.fetch=function(){
      var input=arguments[0];
      var url=typeof input==='string'?input:input&&input.url;
      var add=isAdd(url);
      return oldFetch.apply(this,arguments).then(function(response){
        if(add && response.ok){reset();tick();}
        return response;
      });
    };
  }
  var oldOpen=XMLHttpRequest.prototype.open,oldSend=XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open=function(method,url){this.__nuvozaAdd=isAdd(url);return oldOpen.apply(this,arguments);};
  XMLHttpRequest.prototype.send=function(){
    if(this.__nuvozaAdd)this.addEventListener('load',function(){if(this.status>=200&&this.status<300){reset();tick();}},{once:true});
    return oldSend.apply(this,arguments);
  };
  function onQuantityAction(e){
    var drawer=document.getElementById('CartDrawer');
    if(!drawer || !drawer.contains(e.target))return;
    if(!e.target.closest('.product-quantity__button, .js-cart-product-remove, .nuvoza-upsell-add'))return;
    if(isExpired()){reset();tick();}
  }
  function syncOpen(){
    var drawer=document.getElementById('CartDrawer');if(!drawer)return;
    var open=drawer.classList.contains('js-drawer-open');
    if(open && !drawerWasOpen && isExpired())reset();
    drawerWasOpen=open;
    tick();
  }
  function init(){
    var container=document.getElementById('CartContainer');
    if(container && !container.dataset.nuvozaTimerObserved){
      container.dataset.nuvozaTimerObserved='true';
      new MutationObserver(tick).observe(container,{childList:true,subtree:true});
    }
    var drawer=document.getElementById('CartDrawer');
    if(drawer){
      drawerWasOpen=drawer.classList.contains('js-drawer-open');
      new MutationObserver(syncOpen).observe(drawer,{attributes:true,attributeFilter:['class']});
    }
    tick();
    activateIfCartHasItems();
  }
  document.addEventListener('click',onQuantityAction,true);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
  setInterval(tick,250);
  document.addEventListener('theme:cart:updated',tick);
})();
